import { SECOND } from '../utils/time';

const RoundCount = 5;
const RoundPass = Math.floor(RoundCount * 0.6);


export default {
    name: 'WisconsinCard Sorting',
    level: [
        {
            practice: true,
            name: 'ทดลองเล่น',
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: 3,
            score: 1,
            passScore: 3,
        },
        {
            name: 'คำสั่งที่ 1',
            level: 1,
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'คำสั่งที่ 2',
            level: 2,
            displayTime: 4 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'คำสั่งที่ 3',
            level: 3,
            displayTime: 3 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        }
    ],
}